import React, {useEffect} from 'react'

import Box from '@material-ui/core/Box'

import StepLevelBlocks from '../StepLevelBlocks'

const StepWithBlocksComponentView = (props) => {
    const { enabledBlocks } = props

    useEffect(() => {

    }, [props.selectedStep])


    const currentDocumentId = props?.match?.params?.id || " "

    return (
        <React.Fragment>
            <StepLevelBlocks {...props} currentDocumentId={currentDocumentId} blocks={enabledBlocks} />
        </React.Fragment>
    )
}

export default StepWithBlocksComponentView